
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/how-vahak-helps",
      function () {
        return require("private-next-pages/web/how-vahak-helps.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web/how-vahak-helps"])
      });
    }
  